<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Walkies Career Request
          <v-progress-circular
            v-if="isMasterLoading"
            class="ml-5"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4"> </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.start_time"
                outlined
                label="Start Time"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.end_time"
                outlined
                label="End Time"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.max_distance_km"
                outlined
                label="Max Distance KM"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.min_pet_age"
                outlined
                label="Min Pet Age"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.max_pet_age"
                outlined
                label="Max Pet age"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn v-can:edit="'pet_trainer_requests'"
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Walkies Career Request
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "Walkies Career RequestCreatePage",
  data() {
    return {
      form: {
        name: "",
      },
      service_typeItems: [],
      isLoading: false,
      isMasterLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      this.isMasterLoading = true;
      await axios
        .get(`masters?context=services`)
        .then((masters) => {
          masters = masters.data;
          //Position
          masters.service_types.forEach((service_type) => {
            this.service_typeItems.push({
              id: service_type.id,
              text: service_type.description,
              value: service_type.id,
            });
          });
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isMasterLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        await axios
          .post("/services", this.form)
          .then(async () => {
            await this.saveUserTimestamp(null, this.form);
            this.isLoading = false;
            this.$router.push("/services");
          })
          .catch((error) => {
            console.error(error);
            this.isUnAuthorised();
          });
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
